export enum NewsletterAudience {
  SCHOOL_WIDE = "SCHOOL_WIDE",
  BRANCH_SPECIFIC = "BRANCH_SPECIFIC",
  GRADE_SPECIFIC = "GRADE_SPECIFIC",
  TEACHERS_ONLY = "TEACHERS_ONLY",
  PARENTS_ONLY = "PARENTS_ONLY",
}
